export var privacyStringOptions = [
    {
        value: 'NSCalendarsUsageDescription',
        label: 'Calendar Usage (NSCalendarsUsageDescription)',
    },
    {
        value: 'NSCameraUsageDescription',
        label: 'Camera Usage (NSCameraUsageDescription)',
    },
    {
        value: 'NSContactsUsageDescription',
        label: 'Contacts Usage (NSContactsUsageDescription)',
    },
    {
        value: 'NSLocationWhenInUseUsageDescription',
        label: 'Location when in use (NSLocationWhenInUseUsageDescription)',
    },
    {
        value: 'NSPhotoLibraryAddUsageDescription',
        label: 'Photo library add (NSPhotoLibraryAddUsageDescription)',
    },
    {
        value: 'NSPhotoLibraryUsageDescription',
        label: 'Photo library usage (NSPhotoLibraryUsageDescription)',
    },
];
